import { z } from 'zod'
import { ISODate } from './primitives.ts'

/**
 * ══ HỢP ĐỒNG API — THỐNG KÊ · HIỆU QUẢ NHÀ THẦU · DASHBOARD (F26) ════════════════════════════
 * Nguồn sự thật duy nhất cho `/api/v1/az/thong-ke`.
 *
 * ⚠ CHỈ CÓ CỬA ĐỌC, và sẽ mãi như vậy. Một báo cáo ghi được là một nguồn sự thật thứ hai; số ở đây
 *   phải sửa được bằng cách sửa ĐƠN, HÓA ĐƠN hay KHOẢN CHI PHÍ, không bằng cách sửa báo cáo.
 *
 * ⚠ MỌI SỐ Ở ĐÂY LÀ GIÁ VỐN hoặc suy ra được giá vốn (biết doanh thu và lãi gộp là biết giá vốn),
 *   nên cửa khai `cost:read` + `costFields: true`, đúng như màn chi phí đơn hàng.
 */

/**
 * Kỳ báo cáo. KHÔNG có mặc định "tháng này" ở đây — người gọi phải nói rõ kỳ.
 * ⚠ Mặc định ngầm ở tầng hợp đồng là cách hai màn cùng gọi một cửa mà ra hai kỳ khác nhau, rồi
 *   người đọc so hai con số không so được với nhau.
 */
/** CƠ SỞ NGÀY (`dateOfBasis`): ngày bốc kế hoạch · bốc thực tế · xuất hóa đơn. Trống = kế hoạch. */
export const DateBasis = z.enum(['plan', 'actual', 'invoice'])
export type DateBasisT = z.infer<typeof DateBasis>

export const StatsQuery = z.object({ from: ISODate, to: ISODate, basis: DateBasis.optional() })

export type StatsQueryT = z.infer<typeof StatsQuery>

/**
 * 📊 Dashboard ▸ Tổng quan — khối SẢN LƯỢNG · BÁO CÁO VỎ LẠNH (`0122`). Hai kỳ đối chiếu do MÀN gửi — cùng luật với các thẻ KPI
 * phía trên (`shiftMonths`), để thẻ doanh thu vỏ lạnh và thẻ doanh thu chung so cùng một khoảng.
 */
export const OverviewQuery = z.object({
  from: ISODate, to: ISODate, basis: DateBasis.optional(),
  prevFrom: ISODate, prevTo: ISODate, yoyFrom: ISODate, yoyTo: ISODate,
})
export type OverviewQueryT = z.infer<typeof OverviewQuery>

/**
 * 📊 Dashboard ▸ Tổng quan — biểu đồ "Doanh thu, chi phí, lợi nhuận <năm> theo tháng" (`0148`). Công thức BẢN CŨ: doanh thu =
 * hoá đơn bán theo ngày chứng từ, chi phí = bốn ô chi phí trên đơn (anh chốt 02/10/2026).
 */
export const YearChartQuery = z.object({ year: z.coerce.number().int().min(2000).max(2100) })
export type YearChartQueryT = z.infer<typeof YearChartQuery>

/**
 * 📈 Hiệu quả thầu phụ (`VendorPnlTab`). Rỗng = tất cả. Ngày là NGÀY BỐC thực tế; `period` chỉ chốt kỳ bảng kê cuối tháng.
 * POST vì ba danh sách id có thể dài (chọn nhiều nhà thầu · dịch vụ · khách).
 */
export const VendorPnlBody = z.object({
  vendorIds: z.array(z.string().uuid()).max(500),
  packIds: z.array(z.string().uuid()).max(200),
  customerIds: z.array(z.string().uuid()).max(2000),
  from: z.union([ISODate, z.literal('')]),
  to: z.union([ISODate, z.literal('')]),
  oneVendor: z.boolean(),
  period: z.union([z.string().regex(/^\d{4}-\d{2}$/), z.literal('')]),
})
export type VendorPnlBodyT = z.infer<typeof VendorPnlBody>
